import type { StudioPermission } from "@dnceclub/shared";
import { useStudioContext } from "../contexts/studio-context";

export function usePermission() {
  const { isOwner, currentStudioPermissions } = useStudioContext();

  const hasPermission = (permission: StudioPermission): boolean => {
    if (isOwner) return true;
    return currentStudioPermissions?.[permission] === true;
  };

  const hasAnyPermission = (permissions: StudioPermission[]): boolean => {
    if (isOwner) return true;
    return permissions.some((p) => currentStudioPermissions?.[p] === true);
  };

  const hasAllPermissions = (permissions: StudioPermission[]): boolean => {
    if (isOwner) return true;
    return permissions.every((p) => currentStudioPermissions?.[p] === true);
  };

  return { hasPermission, hasAnyPermission, hasAllPermissions, isOwner };
}
